import type { ReactNode } from 'react';
import './card.css';

interface CardProps {
  title?: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  padded?: boolean;
  className?: string;
}

/** The white panel every screen is built from. */
export function Card({ title, icon, actions, children, padded = true, className = '' }: CardProps) {
  return (
    <section className={`card ${className}`}>
      {(title || actions) && (
        <header className="card__head">
          <div className="card__title">
            {icon && <span className="card__icon">{icon}</span>}
            <span>{title}</span>
          </div>
          {actions && <div className="card__actions">{actions}</div>}
        </header>
      )}
      <div className={padded ? 'card__body' : ''}>{children}</div>
    </section>
  );
}
